import { Card, CardContent } from '@up2stay/up2promo-ui';
import { cn } from '@up2stay/up2promo-ui';
import type { ReactNode } from 'react';

/** Profiles SoT section title (`--t-h3`) for Lead detail cards. */
export const LEAD_DETAIL_SECTION_TITLE_CLASS =
  'text-[15.5px] font-bold leading-tight text-foreground';

type LeadDetailSectionCardProps = {
  children: ReactNode;
  className?: string;
  contentClassName?: string;
};

/**
 * Shared Lead-detail section shell — Card + Profiles density (`p-5 sm:p-6`).
 */
export function LeadDetailSectionCard({
  children,
  className,
  contentClassName,
}: LeadDetailSectionCardProps) {
  return (
    <Card className={cn('min-w-0 overflow-hidden', className)}>
      <CardContent
        className={cn('flex flex-col gap-3 p-5 sm:p-6', contentClassName)}
      >
        {children}
      </CardContent>
    </Card>
  );
}
